export const SUPPORT_IMPERSONATION = 'SUPPORT_IMPERSONATION';
export const IMPERSONATION_TOKEN_PARAM = 'impersonate_token';

const IMPERSONATION_FLAG_KEY = 'impersonationMode';
const AUTH_STORE_KEY = 'authStore';

export type ImpersonationTokenPayload = {
	sub: string;
	actorSub: string;
	tokenUse: typeof SUPPORT_IMPERSONATION;
	exp: number;
};

export const decodeJwtPayload = <T>(token: string): T | null => {
	try {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
		return JSON.parse(new TextDecoder().decode(bytes)) as T;
	} catch {
		return null;
	}
};

export const isImpersonationMode = (): boolean => {
	return sessionStorage.getItem(IMPERSONATION_FLAG_KEY) === 'true';
};

export const getAuthStorage = (): Storage => {
	return isImpersonationMode() ? sessionStorage : localStorage;
};

export const bootstrapImpersonation = (): void => {
	const url = new URL(window.location.href);
	const token = url.searchParams.get(IMPERSONATION_TOKEN_PARAM);
	if (!token) return;

	url.searchParams.delete(IMPERSONATION_TOKEN_PARAM);
	window.history.replaceState(null, '', url.toString());

	const payload = decodeJwtPayload<ImpersonationTokenPayload>(token);
	if (payload?.tokenUse !== SUPPORT_IMPERSONATION || payload.exp * 1000 <= Date.now()) return;

	sessionStorage.setItem(IMPERSONATION_FLAG_KEY, 'true');
	sessionStorage.setItem(
		AUTH_STORE_KEY,
		JSON.stringify({
			state: { accessToken: token, user: null, company: null, isPasswordExpired: false },
			version: 0,
		}),
	);
};

export const getImpersonationPayload = (): ImpersonationTokenPayload | null => {
	if (!isImpersonationMode()) return null;
	const stored = sessionStorage.getItem(AUTH_STORE_KEY);
	try {
		const token = stored && JSON.parse(stored)?.state?.accessToken;
		return token ? decodeJwtPayload<ImpersonationTokenPayload>(token) : null;
	} catch {
		return null;
	}
};

export const endImpersonation = (): void => {
	sessionStorage.clear();
	window.close();
	window.location.replace('/sign-in');
};
